<div class="dropdown-container">
  <!-- Trigger Button -->
  <!-- <button class="dropdown-toggle" (click)="toggleDropdown()">
    {{ selectedItem() }}
    <span class="arrow" [class.open]="isOpen()">▼</span>
  </button> -->

  <!-- Dropdown Menu -->
  @if (isOpen()) {
    <ul class="dropdown-menu">
      <!-- @for (item of items; track item) { -->
        <li (click)="selectItem('quest')">
          <div class="d-flex flex-column rq-info">
            <div class="icons d-flex align-items-center justify-content-center" [innerHTML]="getQuestIcons()"></div>
            <div class="name-quest d-flex align-items-center justify-content-center">
              <span>{{ getQuestName() }}</span>
            </div>
          </div>
        </li>
      <!-- } -->
    </ul>
  }
</div>
